import React from 'react'
import { useRef } from 'react';
import {Link} from "react-router-dom"

export default function Footer() {
  const ref = useRef(null);

  const handleClick = () => {
    //e.preventDefault();
    ref.current.scrollIntoView();
   // e.preventDefault();

  };
  return (
    <div>
      <div className="page-footer font-small"  style={{marginTop:"70px", backgroundColor:"#00838f"}}>
      <div className="container">

      <div className="row">
      <div className="col-md-12 py-5">
        <div className='my-5 row mx-2'>
          <h4 className='col-md-4'>College Book</h4>
        
            <div className="col-md-1">
            <Link className='text-dark' to="/Contact" >Contact</Link>
            
            </div>
            <div className='col-md-1'>
            <Link className='text-dark' to="/About">About</Link>
            </div>
            <div className='col-md-2'>
            <Link className='text-dark 'to='/Terms'onClick={()=>{handleClick()}} >Terms & Privacy</Link>
            </div>
            <div className='col-md-2'>
            <Link className='text-dark'to='/Copyright'>Copyright</Link>
            </div>
          </div> 
      </div>
       </div>
    </div>
        <div className="footer-copyright text-center py-3" style={{ backgroundColor:"#006064"}}>© 2022 Copyright:
            <b> CollegeBooks.in</b>
          </div>
  
</div>

    </div>
  )
}

